import Faq from "../../components/home/Faq";
import { useTranslation } from "react-i18next";

import Member from "../../components/home/Member";
import { useState } from "react";
import Register from "./Register";
import Reasons from "../../components/home/Reasons";
import Footer from "../../layout/Footer";
import Competitors from "./Competitors";
import Main from "./Main";
import HR from "../../assets/higherRight.svg"
import LR from "../../assets/Lower Right.png"
// import CTA from "../../assets/wave.svg"
import Reasons1 from "@components/home/Reasons1";
import StepsComponent from "@components/home/StepsComponent";
import { scale } from "framer-motion";
import { Import } from "lucide-react";
import Partner from "./Partner";
import Partners from "./Partners";

const Home = ({ handleLogin }) => {
  const { t } = useTranslation();

  const [show, setShow] = useState(false);
  const [activeForm, setActiveForm] = useState("in"); // "in" or "up"

  const openModal = (formType = "in") => {
    setActiveForm(formType);
    setShow(true);
  };

  return (
    <section className="w-100" >

      <Main openModal={openModal} />
      <Register
        show={show}
        setShow={setShow}
        handleLogin={handleLogin}
        activeForm={activeForm}
        setActiveForm={setActiveForm}
      />
      {/* <div className="position-relative d-flex justify-content-end">
  <img src={CTA} className="img-fluid w-100" alt="Description" />
  <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center">
    <Reasons1 />
  </div>
</div> */}
      <div className="position-relative">
        <img src={HR} className="d-none d-xl-flex img-fluid w-75 ms-auto" alt="" style={{ opacity: 0.5 }} />

        <div className="d-none d-xl-flex position-absolute top-0 start-0 w-100 h-100 align-items-center justify-content-center">
          <Reasons1 />
        </div>
      </div>

      {/* Version mobile (normal flow) */}
      <div className="d-block d-xl-none">
        <Reasons1 />
      </div>
      {/* <div className="bg-white" style={{ position: 'relative', zIndex: 2 }}> */}

        <div className="">

          <Reasons t={t} />

                <div className="position-relative">
        <img src={HR} className="d-none d-xl-flex img-fluid w-75 me-auto" alt="" style={{ opacity: 0.5, rotate: "180deg" }} />

        <div className="d-none d-xl-flex flex-column position-absolute top-0 start-0 w-100 h-100  justify-content-start ">
           <Competitors t={t} />
           
           <Partners t={t}/>
        </div>
        
      </div>

      {/* Version mobile (normal flow) */}
      <div className="d-block d-xl-none container-xl">
        <Competitors t={t} />
      </div>
         
<div className="container-xl">
 <StepsComponent t={t} />

          <Faq />
          <Member t={t} openModal={openModal} />
</div>
         
        </div>

    
      <Footer t={t} />
    </section>
  );
};

export default Home;
